export default "__VITE_ASSET__3a311fdb__"